module.exports = __webpack_public_path__ + "img/08-24-158.04718717.jpg";